import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { TechImg } from '@common/external/icons8';
import ToolTip from '@common/tooltip';

const StyledArticle = styled.dl`
  display: inline;
  position: relative;
  align-items: center;
  & > dt {
    margin-bottom: 1rem;
  }
  & > div {
    display: flex;
    flex-wrap: wrap;
  }
  & dd {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  @media (max-width: 768px) {
    padding: 10px;
    background-color: var(--main2-bg-color);
    border-radius: 1.5rem;
    & > dt {
      margin-top: 1rem;
    }
    & > div {
      justify-content: start;
      font-size: 13px;
      width: 100%;
      gap: 15px;
    }
    & dd {
      position: relative;
      flex-basis: calc(33.3% - 10px);
    }
    & dd:nth-child(3n + 1) > .tooltip {
      left: 0;
      align-items: start;
    }
    & dd:nth-child(3n) > .tooltip {
      right: 0;
      align-items: end;
    }
    & .tooltip {
      position: absolute;
      z-index: 10;
      top: 100%;
    }
  }

  @media not (max-width: 768px) {
    padding: 1.5rem 1rem;
    &:before {
      position: absolute;
      content: '';
      z-index: -1;
      top: 0;
      left: 0;
      right: 0;
      height: 175px;
      background-color: var(--main2-bg-color);
      border-radius: 1.5rem;
    }
    &,
    & > div {
      gap: 10px;
    }
    & dd {
      width: 5rem;
      gap: 5px;
    }
  }
`;

const StyledDD = styled.dd`
  cursor: pointer;
  box-sizing: border-box;

  & > button {
    width: 100%;
    padding: 10px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
    border-radius: 10px;
    background-color: transparent;
    border: 1px solid transparent;
    &:hover {
      background-color: #eeeeee;
    }
  }

  &.selected > button {
    background-color: #eeeeee;
    border-color: lightgray;
  }

  &:not(.selected) > .tooltip {
    display: none;
  }
`;

const techList = [
  {
    title: 'Language',
    items: ['JAVA', 'Javascript', 'Python', 'C++', 'C', 'C#'],
  },
  {
    title: 'Back-end',
    items: ['Nodejs', 'Spring'],
  },
  {
    title: 'Database',
    items: ['Firebase', 'MariaDB', 'MySQL'],
  },
  {
    title: 'DevOps',
    items: ['Kubernetes', 'Docker', 'jenkins', 'VMWare'],
  },
  {
    title: 'WAS',
    items: ['NginX', 'Tomcat'],
  },
  { title: 'Cloud', items: ['GCP'] },
  {
    title: 'Front-end',
    items: ['React', 'HTML', 'CSS'],
  },
  {
    title: 'Collaboration Tools',
    items: ['Jira', 'Confluence', 'Gerrit', 'Bitbucket', 'Git'],
  },
  {
    title: 'Linting Tools',
    items: ['ESLint', 'Prettier'],
  },
];

const SectionTech = () => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (selected) {
      selected.classList.add('selected');
      return () => {
        selected.classList.remove('selected');
      };
    }
  }, [selected]);

  const onClickTech = (target) => {
    if (target.tagName !== 'DD') {
      onClickTech(target.parentNode);
    } else {
      setSelected(target);
    }
  };

  return (
    <div>
      {techList.map((article) => (
        <StyledArticle key={`article_${article.title}`}>
          <dt>{article.title}</dt>
          <div>
            {article.items.map((item) => (
              <StyledDD key={`item_${item}`}>
                <button onClick={(e) => onClickTech(e.target)}>
                  {TechImg(item)}
                  <span>{item}</span>
                </button>
                <ToolTip position="bottom">
                  {t(`tooltip_${item.toLowerCase()}`)}
                </ToolTip>
              </StyledDD>
            ))}
          </div>
        </StyledArticle>
      ))}
    </div>
  );
};

export default SectionTech;
